import { UserState } from './user.model';

export const userInitialState: UserState = {
  storeStatus: undefined,
  userType: 'default',
  entryType: undefined,
  isQuoting: false,
  kinId: undefined,
  kinPersonId: undefined,
  kinSegmentId: '',
};
